<template>
  <div class="nav-shell">
    <b-navbar
      class="app-navbar"
      toggleable="lg"
      type="dark"
      variant="dark"
    >
      <b-container class="nav-container">
        <b-navbar-brand to="/" class="nav-brand">
          <span class="brand-highlight">E. Richter</span>
          <span class="brand-rest">IAMS</span>
        </b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav class="nav-collapse">
          <b-navbar-nav class="text-white nav-left">
            <b-nav-item to="/">Startseite</b-nav-item>
            <b-nav-item to="/callcenter"
              >Auftragsannahme<NewBadge eol="2023-03-14"></NewBadge
            ></b-nav-item>
            <b-nav-item-dropdown text="Auftragsverwaltung">
              <b-dropdown-item to="/workView">Arbeitsansicht</b-dropdown-item>
              <b-dropdown-item to="/all-orders">Alle Aufträge</b-dropdown-item>
              <b-dropdown-item to="/cancelled-orders"
                >Stornierte Aufträge</b-dropdown-item
              >
              <hr v-if="this.$user.admin == 1" />
              <b-dropdown-item v-if="this.$user.admin == 1" to="/job-money-transfer"
                >Auftrags&uuml;berweisungen</b-dropdown-item
              >
              <b-dropdown-item v-if="this.$user.admin == 1" to="/job-money-transfer-cancelled"
                >Ausbuchungen</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto nav-right">
            <b-nav-item v-if="this.$user.admin == 1" to="/accounting">
              Buchhaltung
            </b-nav-item>
            <b-nav-item-dropdown v-if="this.$user.admin == 1" text="Verwaltung">
              <b-dropdown-item to="/management/customer">Kunden</b-dropdown-item>
              <b-dropdown-item to="/management/employee">Monteure</b-dropdown-item>
              <b-dropdown-item to="/management/mediators">Zentralen</b-dropdown-item>
              <b-dropdown-item to="/management/contractTypes">Einsatztypen</b-dropdown-item>
              <b-dropdown-item to="/management/templates">Vorlagen</b-dropdown-item>
              <b-dropdown-item to="/management/debtCollectionEmployee">Inkasso-Mitarbeiter</b-dropdown-item>
              <b-dropdown-item to="/management/user">Benutzer</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item @click="openSearch"
              ><b-icon-search></b-icon-search
            ></b-nav-item>
            <b-nav-item-dropdown text="Benutzer">
              <template v-slot:button-content>
                <b-icon-person-fill></b-icon-person-fill>
              </template>
              <b-dropdown-item disabled>{{
                this.$user.username
              }}</b-dropdown-item>
              <b-dropdown-item to="/user/settings"
                >Einstellungen</b-dropdown-item
              >
              <b-dropdown-item to="/logout">Abmelden</b-dropdown-item>
            </b-nav-item-dropdown>

            <b-nav-item to="/notifications"
              ><b-icon-bell></b-icon-bell
              ><NotificationBadge
                :items="notificationCount"
              ></NotificationBadge>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
var instance;
import NewBadge from "@/components/objcs/NewBadge.vue";
import NotificationBadge from "@/components/objcs/NotificationBadge.vue";
export default {
  name: "AppNavigation",
  components: {
    NewBadge,
    NotificationBadge,
  },
  data: function () {
    return {
      timer: -200,
      search: this.$search,
      notificationCount: "0",
    };
  },
  methods: {
    openSearch: function () {
      instance.$root.search = true;
    },
    getNotificationCount: function () {
      this.$root.apiRequest("/notification", {}, (response) => {
        this.notificationCount = response.data.result.count;
      }, undefined, true);
    },
  },
  mounted() {
    instance = this;
    this.getNotificationCount();
    this.timer = setInterval(function() {
      instance.getNotificationCount();
    }, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style scoped>
.nav-shell {
  position: sticky;
  top: 0;
  z-index: 1030;
}

.app-navbar {
  min-height: 2.9rem;
  border-bottom: 1px solid #395170;
  background: linear-gradient(90deg, #1f2c3d, #29405d) !important;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.nav-container {
  align-items: center;
}

.nav-brand {
  display: inline-flex;
  align-items: baseline;
  gap: 0.45rem;
  margin-right: 1rem;
  padding: 0;
  line-height: 1;
  font-weight: 700;
}

.brand-highlight {
  color: #ffec3c;
  text-shadow: 1px 1px 0 rgba(0, 0, 0, 0.28);
}

.brand-rest {
  font-size: 0.85rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #d8e4f1;
}

.nav-collapse {
  z-index: 1000;
}

.nav-left,
.nav-right {
  background: transparent;
}

.app-navbar :deep(.navbar-toggler) {
  border-radius: 0;
  border-color: #8ea4bc;
  padding: 0.15rem 0.45rem;
}

.app-navbar :deep(.nav-link),
.app-navbar :deep(.dropdown-toggle) {
  border-radius: 0;
  color: #f3f7fb !important;
  font-weight: 500;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
}

.app-navbar :deep(.nav-link:hover),
.app-navbar :deep(.dropdown-toggle:hover),
.app-navbar :deep(.nav-link.router-link-exact-active) {
  color: #ffec3c !important;
}

.app-navbar :deep(.dropdown-menu) {
  border-radius: 0 !important;
  border: 1px solid #c8d5e3;
  box-shadow: 0 10px 22px rgba(19, 43, 67, 0.16);
  background: #ffffff !important;
  margin-top: 0.15rem;
}

.app-navbar :deep(.dropdown-item) {
  color: #1f344a !important;
  border-radius: 0;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.app-navbar :deep(.dropdown-item:hover),
.app-navbar :deep(.dropdown-item:focus) {
  background: #edf3fa !important;
  color: #0f3c75 !important;
}

.app-navbar :deep(.dropdown-divider) {
  border-top-color: #dbe4ee;
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-collapse {
    display: contents !important;
  }
}

@media (max-width: 991px) {
  .nav-collapse {
    margin-top: 0.4rem;
    border-top: 1px solid #496380;
    padding-top: 0.45rem;
  }

  .nav-left,
  .nav-right {
    background: #213248;
    border: 1px solid #4a627d;
    padding: 0.35rem 0.45rem;
  }

  .nav-right {
    margin-top: 0.45rem;
  }
}
</style>
